// @ts-nocheck
import React from 'react';
import { Provider } from 'react-redux';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import svLocale from 'date-fns/locale/sv';

import { createAppTheme } from '../../theme';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/fraunces/600.css';

import AppRouter from './AppRouter';
import Auth from '../Auth/Auth';
import Toast from '../Toast/Toast';

import store from '../../redux';

const theme = createAppTheme();

const App: React.FC = () => {
    return (
        <React.StrictMode>
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={svLocale}>
                        <CssBaseline />
                        <Toast />
                        <Auth>
                            <AppRouter />
                        </Auth>
                    </LocalizationProvider>
                </ThemeProvider>
            </Provider>
        </React.StrictMode>
    );
};

export default App;
